import axios from "@/axios-service";
import { ResponseContent, responseContent } from "../types";
import { VegetationIndexAverage, VegetationIndexCrop } from "./types";

const MS_URL = "/senana/farm/";
const responseAsVegAverage = responseContent(VegetationIndexAverage);
const responseAsVegCrop = responseContent(VegetationIndexCrop);

export const findAllAveragesByAnalysisAndType = async (
  uuid: string, 
  vegetationIndexType: string,
  cropType: string = "SOY",
  harvestSeason: string = "SUMMER",
): Promise<ResponseContent<VegetationIndexAverage[]>> =>
  axios
  .get(`${MS_URL}/analysis/${uuid}/vegetation-indexes/${vegetationIndexType}`,{
    params: {
      crop_type: cropType,
      harvest_season: harvestSeason 
    }
  })
  .then(responseAsVegAverage);

export const findAllAveragesByAnalysisForCropTypeNotConfirmed = async (
  uuid: string, 
  vegetationIndexType: string,
  cropType: string = "SOY",
  harvestSeason: string = "SUMMER",
): Promise<ResponseContent<VegetationIndexAverage[]>> =>
  axios
  .get(`${MS_URL}/analysis/${uuid}/vegetation-indexes/${vegetationIndexType}/not-confirmed`,{
    params: {
      crop_type: cropType,
      harvest_season: harvestSeason 
    }
  })
  .then(responseAsVegAverage);

export const findAllByCropAndType = async (
  cropUuid: string, vegetationIndexType: string
): Promise<ResponseContent<VegetationIndexCrop[]>> =>
  axios.get(`${MS_URL}/crop/${cropUuid}/vegetation-indexes/${vegetationIndexType}`).then(responseAsVegCrop);

